var map = {
	"./double-arrow.svg": 2809,
	"./expanding-blue.svg": 3426,
	"./expanding-green.svg": 1776,
	"./expanding-orange.svg": 3003,
	"./per-minute.svg": 7094,
	"./per-ride.svg": 8292,
	"./ride-ceva.svg": 3832,
	"./ride-stats.svg": 3747,
	"./total.svg": 5701,
	"./triple-arrow.svg": 3631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2031;